import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateProfileField, blurProfileField } from 'redux/profiles/ProfilesActions';
import ConnectedTextField from "./ConnectedTextField";

const mapStateToProps = (state, ownProps) => ({
  value: state.profiles.profile[ownProps.name],
  pristineForm: state.profiles.pristineForm
});

const mapDispatchToProps = dispatch => ({
  profilesActions: bindActionCreators({ updateProfileField, blurProfileField }, dispatch)
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  profilesActions: {
    ...dispatchProps.profilesActions,
    updateProfileField: value => dispatchProps.profilesActions.updateProfileField(ownProps.name, value)
  }
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ConnectedTextField);



// WEBPACK FOOTER //
// ./src/shared/components/connectedTextField/ConnectedTextFieldConnector.js